// Interface not complete. Only mapped field used in parseColumns.
// Feel free to extend it.
export interface ITableConfig {
    tableViewName: string;
    translationPrefix: string;
    paginator: boolean,
    rowsPerPage: number,
    fileName: string;
    clazz: string;
    adminOnly: boolean,
    pinnedTopRow: boolean,
    columns: any[];
    // Default sort by field.
    defaultSortBy?: string;
    // Default sort by order.
    defaultDir?: string;
    // Multi-sort option. Overwrites defaultSortBy,defaultDir when present.
    defaultSortOptions?: IDefaultSortOption[];
}

export interface IDefaultSortOption {
    sort: string,
    dir: string;
}

export enum ExportType {
    EXCEL = 'EXCEL',
    CSV = 'CSV'
}